import { Box, ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { formatDate } from "date-fns";
import ReactGA from 'react-ga4';
import { useNavigate } from "react-router";
import BetaBadge from "src/components/BetaBadge.component";
import { SCREEN_NAMES } from "src/constants/screenNames";

interface LinkMenuItemProps {
  path: string;
  selectedDate: Date | null;
  primaryText: string;
  secondaryText: string;
  icon: React.ReactNode;
  /** ベータ版機能であることを示すバッジを primaryText の右側に表示する */
  beta?: boolean;
};

export const LinkMenuItem = ({
  path,
  selectedDate,
  primaryText,
  secondaryText,
  icon,
  beta = false,
}: LinkMenuItemProps) => {
  const navigate = useNavigate();

  const handleDateMenuItemClick = (path: string) => {
    const date = formatDate(selectedDate || new Date(), 'yyyy-MM-dd');
    ReactGA.event('click', { screen_name: SCREEN_NAMES.DASHBOARD, button_name: 'date', label: date });

    console.log(`Navigate to: /${path}/${date}/${date}`);
    void navigate(`/${path}/${date}/${date}`);
  };

  const primary = beta ? (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
      {primaryText}
      <BetaBadge />
    </Box>
  ) : primaryText;

  return (
    <MenuItem onClick={() => handleDateMenuItemClick(path)}>
      <ListItemIcon>
        {icon}
      </ListItemIcon>
      <ListItemText
        primary={primary}
        secondary={secondaryText}
      />
    </MenuItem>
  );
};
